const supportedLanguage = [
    'nl',
    'zh',
    'tr',
    'sv',
    'sk',
    'sl',
    'ru',
    'ro',
    'pt',
    'pl',
    'no',
    'lv',
    'lt',
    'hu',
    'hr',
    'fi',
    'fr',
    'et',
    'el',
    'da',
    'cs',
    'bg',
    'en',
    'es',
    'de',
    'it',
    'it-dom'
]


const createLanguage = props => {
    let defaultLanguage = {};

    supportedLanguage.map(async language => {
        try {
            defaultLanguage[language] = require('./defaultText_'+language+'.json');
        } catch (error) {}

        if (defaultLanguage[language]  && defaultLanguage[language].text) {
            try {
                let text = require('./screen1Intro_'+language+'.js');
                defaultLanguage[language].text.intro = text.default;
            } catch (error) {}
        }        
    });

    return defaultLanguage;
};

export default createLanguage();